import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { ROUTE_PATH } from '@app/shared/enum/common.enum';
import { filter } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class NavigationHistoryService {
    private readonly history: string[] = [];

    constructor(
        private readonly router: Router,
        private readonly location: Location
    ) {
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.history.push(event.urlAfterRedirects);
                if (this.history.length > 10) {
                    this.history.shift();
                }
            });
    }

    /**
     * Clears the stored navigation history.
     */
    getPreviousUrl(): string | null {
        return this.history.length > 1
            ? this.history[this.history.length - 2]
            : null;
    }

    /**
     * Navigates to the previous page in the history.
     * If no previous page exists, it will navigate back using the default browser's Location service.
     * If the previous URL is part of a specific route (eg Overview or Production Dashboard), it will navigate to that route.
     */
    navigateToPreviousPage() {
        const prevUrl = this.getPreviousUrl();

        if (!prevUrl) {
            this.location.back();
        } else if (prevUrl.includes(ROUTE_PATH.OVERVIEW)) {
            this.router.navigate([ROUTE_PATH.OVERVIEW]);
        } else if (prevUrl.includes(ROUTE_PATH.PRODUCTION_DASHBOARD)) {
            this.router.navigate([ROUTE_PATH.PRODUCTION_DASHBOARD]);
        } else {
            this.location.back();
        }
    }
}
